export const animate = (props: { duration: number, onUpdate: (time: number) => void, onComplete?: () => void }) => {
  const { duration, onUpdate, onComplete } = props;

  const startTime = performance.now();

  let frameId = 0;

  const animate = () => {
    const time = performance.now();
    const elapsed = time - startTime;

    onUpdate(elapsed / duration);

    if (elapsed < duration) {
      frameId = requestAnimationFrame(animate);
    } else {
      onComplete?.();
    }
  }

  animate();

  return () => {
    cancelAnimationFrame(frameId);
  }
}